/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const ListSkillVersionsQueryParamOrder = {
  Asc: "asc",
  Desc: "desc",
} as const;
export type ListSkillVersionsQueryParamOrder = ClosedEnum<
  typeof ListSkillVersionsQueryParamOrder
>;

export type ListSkillVersionsRequest = {
  skillId: string;
  after?: string | undefined;
  limit?: number | undefined;
  order?: ListSkillVersionsQueryParamOrder | undefined;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const ListSkillVersionsQueryParamOrder$inboundSchema: z.ZodNativeEnum<
  typeof ListSkillVersionsQueryParamOrder
> = z.nativeEnum(ListSkillVersionsQueryParamOrder);
/** @internal */
export const ListSkillVersionsQueryParamOrder$outboundSchema: z.ZodNativeEnum<
  typeof ListSkillVersionsQueryParamOrder
> = ListSkillVersionsQueryParamOrder$inboundSchema;

/** @internal */
export const ListSkillVersionsRequest$inboundSchema: z.ZodType<
  ListSkillVersionsRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  skill_id: z.string(),
  after: z.string().optional(),
  limit: z.number().int().default(20),
  order: ListSkillVersionsQueryParamOrder$inboundSchema.default("desc"),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "skill_id": "skillId",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type ListSkillVersionsRequest$Outbound = {
  skill_id: string;
  after?: string | undefined;
  limit: number;
  order: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const ListSkillVersionsRequest$outboundSchema: z.ZodType<
  ListSkillVersionsRequest$Outbound,
  z.ZodTypeDef,
  ListSkillVersionsRequest
> = z.object({
  skillId: z.string(),
  after: z.string().optional(),
  limit: z.number().int().default(20),
  order: ListSkillVersionsQueryParamOrder$outboundSchema.default("desc"),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    skillId: "skill_id",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function listSkillVersionsRequestToJSON(
  listSkillVersionsRequest: ListSkillVersionsRequest,
): string {
  return JSON.stringify(
    ListSkillVersionsRequest$outboundSchema.parse(listSkillVersionsRequest),
  );
}
export function listSkillVersionsRequestFromJSON(
  jsonString: string,
): SafeParseResult<ListSkillVersionsRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListSkillVersionsRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListSkillVersionsRequest' from JSON`,
  );
}
